<template>
  <div id="loader">
      <img src="@/assets/img/logo.png" alt="icon" class="loading-icon">
      <!-- {{ estado }} - {{ activated }} -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'LoaderBox',
    data() {
        return {
            estado: null,
        };
    },
    props: {
        activated: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        isLoading(a, b) {
            console.log("a, b", a, b)
            if (!a) this.hide();
            else this.show();
        },
    },
    computed: {
        ...mapGetters(['isLoading']),
    },
    methods: {
        async runner() {
            // if (!this.estado) this.hide();
            // else this.show();
            await new Promise((resolve) => {
                const checkLoading = () => {
                if (!this.isLoading) {
                    resolve();
                } else {
                    setTimeout(checkLoading, 100); // Reintentar cada 100 ms
                }
                };
                checkLoading();
            });
        },
        show() {
            var loader =  document.getElementById('loader');
            setTimeout(() => {
                // loader.setAttribute("style", "pointer-events: none; opacity: 0; transition: 0.2s ease-in-out;");
                setTimeout(() => {
                    loader.removeAttribute("style")
                }, 1000);
            }, 1450);
        },
        hide() {
            var loader =  document.getElementById('loader');
            setTimeout(() => {
                loader.setAttribute("style", "pointer-events: none; opacity: 0; transition: 0.2s ease-in-out;");
                setTimeout(() => {
                    loader.setAttribute("style", "display: none;")
                }, 1000);
            }, 1450);
        },
    },
    // Ciclo de vida: antes de crear el componente
    beforeCreate() {
    },
    // Ciclo de vida: cuando se crea el componente
    created() {
        this.loading = true;
    },
    // Ciclo de vida: antes de montar el componente
    beforeMount() {
    },
    // Ciclo de vida: cuando se monta el componente
    async mounted() {
        this.estado = this.activated;
        await this.runner();
        // setTimeout(() => {
        //   // loader.setAttribute("style", "pointer-events: none; opacity: 0; transition: 0.2s ease-in-out;");
        //   setTimeout(() => {
        //     this.loading = true;
        //     // loader.setAttribute("style", "display: none;")
        //   }, 1000);
        // }, 450);
        // setTimeout(() => {
        //   // loader.setAttribute("style", "pointer-events: none; opacity: 0; transition: 0.2s ease-in-out;");
        //   setTimeout(() => {
        //     this.loading = false;
        //     // loader.setAttribute("style", "display: none;")
        //   }, 1000);
        // }, 450);
    },
    // Ciclo de vida: antes de actualizar el componente
    beforeUpdate() {
    },
    // Ciclo de vida: cuando se actualiza el componente
    async updated() {
        await this.runner();
    },
    // Ciclo de vida: antes de destruir el componente
    beforeUnmount() {
    },
    // Ciclo de vida: cuando se destruye el componente
    unmounted() {
    },
    setup() {
    },
}
</script>
